import {ROUTES} from '@/config/constants'
import {LogLevel, PublicClientApplication} from '@azure/msal-browser'

const domain = window.location.origin
const basePath = import.meta.env.VITE_CCT_APP_BASE_PATH || '/'
const redirectBase = basePath === '/' ? `${domain}${ROUTES.ROOT}` : `${domain}${basePath}`

interface AuthConfig {
  clientId: string
  authority: string
  redirectUri: string
  postLogoutRedirectUri: string
}

interface CacheConfig {
  cacheLocation: 'sessionStorage' | 'localStorage'
  storeAuthStateInCookie: boolean
}

interface LoggerOptions {
  LogLevel: LogLevel
  loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => void
}

interface SystemConfig {
  loggerOptions: LoggerOptions
}

interface MsalConfig {
  auth: AuthConfig
  cache: CacheConfig
  system: SystemConfig
}

export const msalConfig: MsalConfig = {
  auth: {
    clientId: import.meta.env.VITE_MSAL_CLIENTID,
    authority: import.meta.env.VITE_MSAL_AUTHORITY,
    redirectUri: redirectBase,
    postLogoutRedirectUri: redirectBase,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      LogLevel: LogLevel.Verbose,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            // console.info(message)
            return
          case LogLevel.Verbose:
            console.debug(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            return
          default:
            return
        }
      },
    },
  },
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ['openid', 'profile', 'User.Read', 'offline_access'],
}

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
}

/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
export const msalInstance = new PublicClientApplication(msalConfig)

// WIP - get accessToken
// export const authAccessToken = () => {
//   try {
//     const tokenStorage = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY)
//     const authStateStorage = JSON.parse(`${tokenStorage}`) as AuthState
//     const accessToken = authStateStorage?.accessToken?.accessToken

//     return `Bearer ${accessToken}`
//   } catch {
//     return ''
//   }
// }
